(function() {
	'use strict';

	angular
		.module('pwc.controllers')
		.controller('WineGiftDialogController', WineGiftDialogController);

	WineGiftDialogController.$inject = ['$window', '$mdDialog', 'WineGift', 'userPouch', 'wine', 'lodash', '$log', 'transaction', 'combinedHistoryIndex', 'MessageService', 'persistOnSave', '$timeout', '$rootScope'];

	function WineGiftDialogController($window, $mdDialog, WineGift, userPouch, wine, lodash, $log, transaction, combinedHistoryIndex, MessageService, persistOnSave, $timeout, $rootScope){

		/* jshint validthis: true */
		var self = this;

		self.wine = wine;

		self.gift = null;

		self.maxBottles = lodash.get(wine, 'cellar.qty');

		self.isEdit = false;

		self.persistOnSave = persistOnSave;

		self.save = save;
		self.closeDialog = closeDialog;

		/** initialize */

		initialize();

		/** begin methods */

		function initialize(){
			if (lodash.isNotEmptyOrNull(transaction)){
				// angular datepicker wants js Date
				// @TODO fix with $mdDateLocaleProvider?
				$timeout(function(){
					transaction.date = lodash.isNotEmptyOrNull(transaction.date) ? $window.moment(transaction.date).toDate() : null;
					self.gift = transaction;
				});

				self.isEdit = true;

				// adjust max bottle limit
				self.maxBottles = lodash.add(lodash.get(wine, 'cellar.qty'), transaction.qty);
			} else {
				self.gift = new WineGift();
			}
		}

		function save(){
			$log.debug('Saving transaction...');

			// @TODO add preUpdate event & handler?

			self.gift.qty = lodash.parseInt(self.gift.qty);

			self.wine.upsertCombinedHistoryItem(self.gift, combinedHistoryIndex);

			if (persistOnSave){
				return _persist();
			} else {
				closeDialog();
				$rootScope.$emit('WineTransactionAddedButNotSaved');
				_showPostSaveToast();
			}
		}

		function closeDialog(){
			return $mdDialog.hide();
		}

		function _showPostSaveToast(){
			var msg = "Gift " + (self.isEdit ? 'Updated' : 'Added') + ". Don't forget to save when done editing.";

			return MessageService.showToast(msg, 5000);
		}

		function _persist(){
			userPouch
				.save(self.wine)
				.then(function(){
					return MessageService.showToast('Gift saved!', 5000);
				})
				.then(closeDialog)
				.catch(function(err){
					$log.error('Error saving wine.', err);
					MessageService.showToast('Unable to save. Please contact support if problem persists', 5000);
				});
		}
	}

})();
